// third-party
import { FormattedMessage } from "react-intl";

// assets
import { HomeTrendUp } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  dashboard: HomeTrendUp,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const dashboard: NavItemType = {
  id: "group-dashboard",
  title: <FormattedMessage id="page.menu_items_dashboard_label" />,
  icon: icons.dashboard,
  type: "group",
  children: [
    {
      id: "dashboard",
      title: <FormattedMessage id="page.menu_items_dashboard_label" />,
      type: "item",
      url: "/dashboard",
      icon: icons.dashboard,
    },
  ],
};

export default dashboard;
